import { usePage } from "@inertiajs/react"

import { ProfileSidebar } from "@/components/features/profiles/profile-sidebar"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { MainContainer } from "@/components/ui/container"

type SharedUser = {
  name: string
  email: string
  initials: string
  avatar: string | null
}

export default function StaffProfilesShow() {
  const { user } = usePage<{ user: SharedUser | null }>().props

  if (!user) return null

  return (
    <StaffLayout>
      <MainContainer size="xs">
        <div className="my-15 flex flex-col items-center gap-3 text-center" data-testid="profile-show-view">
          <Avatar className="size-16">
            <AvatarImage src={user.avatar || ""} alt={user.name} />
            <AvatarFallback className="text-lg">
              {user.initials}
            </AvatarFallback>
          </Avatar>
          <div>
            <h1 className="text-xl font-bold" data-testid="profile-show-name">{user.name}</h1>
            <p className="text-sm text-muted-foreground" data-testid="profile-show-email">{user.email}</p>
          </div>
        </div>

        <ProfileSidebar />
      </MainContainer>
    </StaffLayout>
  )
}
